import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as actions from "../../../store/actions";
import { i18n } from '../../../translate/i18n';
import {
  Container, Paper, Typography, FormControl, FormLabel, IconButton, TextField, FormControlLabel, RadioGroup, Radio, Divider,
  Switch,
  FormHelperText
} from '@mui/material';
import {
  FormStyled, DoneIconStyled, DivSubmitButtons, DivFormTitle,
} from './styles';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBack from '@mui/icons-material/ArrowBack';
import Autocomplete from '../../../UI/Autocomplete/Autocomplete';
import Spinner from '../../../components/Spinner/index';
import Recaptcha from 'react-recaptcha';
import { EAccessRole } from '../../../store/types';
let recaptchaInstance;
const FormParamCreateUsers = (props) => {
  const dispatch = useDispatch();
  const [editMode, setEditMode] = useState(false);
  const [isNewData, setIsNewData] = useState(true);
  const [verified, setVerified] = useState(false);
  const [captcha, setCaptcha] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(50);
  const [orderBy, setOrderBy] = useState("name");
  const [order, setOrder] = useState("asc");
  const [email, setEmail] = useState("")
  const [profile, setProfile] = useState([])
  const [role, setRole] = useState("analyst");
  const [inspector, setInspector] = useState(false);

  const [emailConfirmation, setEmailConfirmation] = useState("");
  const [selectedSites, setSelectedSites] = React.useState([]);
  const [selectedCompanies, setSelectedCompanies] = useState([]);
  const [sitesFormated, setSitesFormated] = useState([])
  const [searchTextSites, setSearchTextSites] = useState("")

  const [emailError, setEmailError] = useState(false);
  const [companiesFormated, setCompaniesFormated] = useState([])
  const [profileError, setProfileError] = useState(false);
  const [sitesError, setSitesError] = useState(false);
  const [emailConfirmationError, setEmailConfirmationError] = useState(false);
  const [emailComparisonError, setEmailComparisonError] = useState(false);

  const [companiesError, setCompaniesError] = useState(false);
  const [searchTextCompanies, setSearchTextCompanies] = useState("")

  const fetchSites = useCallback(
    () => dispatch(actions.fetchSites(1, 30, searchTextSites, order, orderBy)),
    [searchTextSites, order, orderBy]
  );

  const fetchCompanies = useCallback(
    () => dispatch(actions.fetchCompanies(page, limit, searchTextCompanies, order, orderBy)),
    [page, limit, searchTextCompanies, order, orderBy]
  );

  const sites = useSelector(state => state.sites.sites);
  const selectedAccess = useSelector(state => state.auth.selectedAccess);

  const loadingSites = useSelector(state => state.sites.loading);
  const loadingUser = useSelector(state => state.users.loadingTenantUsers);
  const loadingCompanies = useSelector(state => state.companies.loading);
  const companies = useSelector(state => state.companies.companies);

  const isContractor = role === EAccessRole.contractor;
  const isAnalyst = role === EAccessRole.analyst;

  //FUNCTION TO FORMAT DOCUMENT TYPES IN THE AUTOCOMPLETE
  useEffect(() => {
    const dataFromRedux = sites
    let returnArray = []
    dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name }))
    setSitesFormated(returnArray)
  }, [sites])
  useEffect(() => {
    fetchSites(searchTextSites, order, orderBy);
  }, [searchTextSites]);

  useEffect(() => {
    const dataFromRedux = companies
    let returnArray = []
    dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name }))
    setCompaniesFormated(returnArray)
  }, [companies])

  useEffect(() => {
    fetchCompanies(page, limit, searchTextCompanies, order, orderBy);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTextCompanies]);

  //send data to Server (post and update)
  const inviteSignup = (body) => dispatch(actions.inviteSignup(body))
  //const deleteUsers = () => dispatch(actions.deleteUsers(props.match.params.id))
  const handleBack = () => {
    props.history.goBack()
  }
  const verifyCallback = response => {
    if (response) {
      setVerified(true);
      setCaptcha(response)
    } else {
      setVerified(false);
      setCaptcha("")
    }
  }
  const handleSubmit = (e) => {
    e.preventDefault();
    let hasError = false;

    if (isContractor) {
      if (!selectedCompanies.value) {
          hasError = true;
          setCompaniesError(true);
      }
    }

    if (profile.length > 0 && profile[0]) {
      const notUploaded = profile.filter(fl => fl.uploaded === false)
      if (notUploaded.length > 0) {
        setProfileError(true)
        hasError = true;
      }
    }
    if (!email) {
      hasError = true;
      setEmailError(true);
    }
    if (!emailConfirmation) {
      hasError = true;
      setEmailConfirmationError(true);
    }
    if (email !== emailConfirmation) {
      hasError = true;
      setEmailError(true);
      setEmailComparisonError(true);
    }
    let sitesIds = [];
    selectedSites.map(site => sitesIds.push(site.value));
    if (sitesIds.length === 0) {
      setSitesError(true)
      hasError = true;
    }
    if (hasError) return
    const body = {
      email,
      role,
      sites: sitesIds,
      company: selectedCompanies.value,
      captcha,
      companyName: selectedAccess.tenant.name,
      inspector,
    }
    inviteSignup(body).then(result => {
      if (result === 'success') {
        props.history.goBack()
      } else {
        resetRecaptcha()
      }
    })
  }
  const handleInputChangeSelectorSites = (text) => {
    setSearchTextSites(text);
  }
  const handleInputChangeSites = selected => {
    setSitesError(false);
    setSelectedSites(selected)
  }

  const handleInputChangeCompanies = selected => {
    setCompaniesError(false);
    setSelectedCompanies(selected)
  }

  const handleInputChangeSelectorCompanies = (text) => {
    setSearchTextCompanies(text);
  }

  const onChangeEmail = (event) => {
    setEmailError(false);
    setEmailConfirmationError(false);
		setEmailComparisonError(false);
    return setEmail(event.target.value.toLowerCase().trim())
  }
  const onChangeConfirmationEmail = (event) => {
    setEmailError(false);
    setEmailConfirmationError(false);
		setEmailComparisonError(false);
    return setEmailConfirmation(event.target.value.toLowerCase().trim())
  }

  // create a reset function
  const resetRecaptcha = () => {
    recaptchaInstance.reset();
  };
  return <>
    <IconButton onClick={handleBack} style={styles.arrowBack} size="large"><ArrowBack /></IconButton>
    <Container maxWidth='sm'>
      <Paper style={{ position: 'relative' }}>
        {loadingUser && <Spinner overlay />}
        <FormStyled onSubmit={handleSubmit} style={{ opacity: loadingUser ? '0.3' : '1' }}>
          <DivFormTitle>
            <Typography variant='h6'>{i18n.t('typographyformCreateUser.text')}</Typography>
          </DivFormTitle>
          <Divider />
          <>
            <FormControl variant="standard" fullWidth margin='normal' required>
              <TextField
                variant="standard"
                label={i18n.t('textFieldFormCreateUser.email')}
                name='email'
                onChange={event => onChangeEmail(event)}
                value={email}
                margin='normal'
                error={emailError}
                helperText={emailComparisonError ? "" : i18n.t('textFieldFormCreateUser.helperTextEmail')} />
            </FormControl>
            <FormControl variant="standard" fullWidth margin='normal' required>
              <TextField
                variant="standard"
                label={i18n.t('textFieldFormCreateUser.confirmationEmail')}
                name="email"
                onChange={event => onChangeConfirmationEmail(event)}
                value={emailConfirmation}
                error={emailConfirmationError || emailComparisonError}
                helperText={emailComparisonError ? i18n.t('textFieldFormCreateUser.helperTextConfirmationEmail') : ""} />
            </FormControl>
            <FormControl variant="standard" fullWidth margin='normal'>
              <Autocomplete
                isMulti
                loading={loadingSites} //sent to isLoading
                label={i18n.t('autocompleteFromCreateUser.site')}
                data={sitesFormated} // sent to options
                onSelectValue={handleInputChangeSites} // sent to onChange
                valueSelected={selectedSites} // sent to value
                newSearchText={handleInputChangeSelectorSites}
                name='site'
                hasError={sitesError}
              />
            </FormControl>
            <FormControl variant="standard" component="fieldset" margin='normal'>
              <FormLabel component="legend">{i18n.t('formLabelFormCreateUser.text')}</FormLabel>
              <RadioGroup
                aria-label="gender"
                name="role"
                value={role}
                onChange={event => {
                  setRole(event.target.value);
                }}
                margin='normal'
              >
                <FormControlLabel value="admin" control={<Radio disabled={!isNewData && !editMode} />} label={i18n.t('formControlLabelFormCreateUser.admin')} />
                <FormControlLabel value="analyst" control={<Radio disabled={!isNewData && !editMode} />} label={i18n.t('formControlLabelFormCreateUser.analyst')} />

                <FormControlLabel value="contractor" control={<Radio disabled={!isNewData && !editMode} />} label={i18n.t('formControlLabelFormCreateUser.contractor')} />
              </RadioGroup>
            </FormControl>

            { isContractor &&
              <FormControl variant="standard" fullWidth margin='normal'>
                <Autocomplete
                  loading={loadingCompanies} //sent to isLoading
                  label={i18n.t('autocompleteFromCreateUser.companies')}
                  data={companiesFormated} // sent to options
                  onSelectValue={handleInputChangeCompanies} // sent to onChange
                  valueSelected={selectedCompanies} // sent to value
                  newSearchText={handleInputChangeSelectorCompanies}
                  hasError={companiesError} />
              </FormControl>
            }
            { (isContractor || isAnalyst) &&
              <FormControl fullWidth margin='normal'>
                <FormControlLabel
                  control={<Switch checked={inspector} onChange={e => setInspector(e.target.checked)} disabled={!isNewData && !editMode}/> }
                  label={i18n.t('typographyFormParamUser.inspector')}
                />
                <FormHelperText sx={{marginX: 0, marginBottom: 1}}>{i18n.t('typographyFormParamUser.inspectorHelperText')}</FormHelperText>
              </FormControl>
            }

            <Recaptcha
              sitekey="6LeuVO4UAAAAADQBMGsGI-YQEjhSd9q3XQ-HLeGj"
              render="explicit"
              verifyCallback={verifyCallback}
              expiredCallback={verifyCallback}
              ref={e => recaptchaInstance = e}
            />
            <DivSubmitButtons>
              <IconButton onClick={props.history.goBack} size="large">
                <CloseIcon fontSize='large' color='error' />
              </IconButton>
              <IconButton type="submit" disabled={!verified} size="large">
                <DoneIconStyled fontSize='large' />
              </IconButton>
            </DivSubmitButtons>
          </>
        </FormStyled>
      </Paper>
    </Container>
  </>;
}
export default FormParamCreateUsers;
const styles = {
  arrowBack: {
    position: 'fixed',
    marginTop: 10,
  },
  divContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    marginBottom: 50,
  },
  divContainerSmall: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  container: {
    padding: 10,
    margin: 0,
    marginLeft: 50,
    position: 'relative'
  },
  avatarContainer: {
    display: 'flex',
    padding: 20,
    alignItems: 'center',
    justifyContent: 'center',
  },
  avatar: {
    width: 150,
    height: 150,
    marginTop: 20,
  },
  avatarButton: {
    margin: 5,
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  imageInput: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    marginTop: 10,
  },
  buttonEditImage: {
    margin: '10px 0',
  }
}
